import axios from 'axios';
import store from '../redux/store';
import { gtagGentooResponse, gtagRecommendProduct } from './gtag';
import { contents } from '../data/contents';
import { useChatStateStore } from '../zustand/store';

export const getChatbotReply = async function (userMessage, roomId, setIsGeneratingAnswer, requestURL, clientId, apiKey, itemId = 'general', isMobileDevice) {
    const { language } = useChatStateStore.getState();

    try {
        setIsGeneratingAnswer(true);
        const response = await axios.post(requestURL, {
            clientId: clientId,
            requestMessage: userMessage,
            userId: roomId,
            channelId: JSON.parse(isMobileDevice) ? 'mobile' : 'web',
            itemId: itemId,
        }, {
            headers: {
                'x-api-key': apiKey,
            }
        });
        setIsGeneratingAnswer(false);
        const data = response.data.data;
        if (data && data.text) {
            gtagGentooResponse(data.text, roomId, clientId, data.intent);
            if (data.intent === '제공') gtagRecommendProduct(data.text, roomId, clientId);
            return data;
        } else {
            throw new Error('Invalid server response');
        }
    } catch (error) {
        setIsGeneratingAnswer(false);
        return {
            text: [contents.message[language].networkError], 
        };
        // console.error(`Error while calling chatbot API: ${error.message}`);
    }
};

export const getChatbotReplyAnchovy = async function (userMessage, chatUserId, setIsGeneratingAnswer, requestURL, partnerType, apiKey, itemId = 'general', isMobileDevice, partnerId, chatbotId = 1) {
    const { language } = useChatStateStore.getState();

    try {
        setIsGeneratingAnswer(true);
        const response = await axios.post(requestURL, {
            partnerType: partnerType,
            requestMessage: userMessage,
            itemId: itemId,
            chatUserId: chatUserId,
            partnerId: partnerId,
            chatbotId: chatbotId,
            channelId: isMobileDevice ? 'mobile' : 'web',
        }, {
            headers: {
                'x-api-key': apiKey,
            }
        });
        setIsGeneratingAnswer(false);
        const data = response.data;
        if (data && data.text) {
            gtagGentooResponse(data.text, chatUserId, partnerType, data.intent);
            if (data.intent === '제공') gtagRecommendProduct(data.text, chatUserId, partnerType);
            return data;
        } else {
            // throw new Error('Invalid server response');
        }
    } catch (error) {
        setIsGeneratingAnswer(false);
        console.error(`Error while calling chatbot API: ${error.message}`);
        return {text: contents.message[language].networkError};
    }
};


export const resetQueryCondition = async (roomId, requestURL, clientId, apiKey = undefined) => {
    const userId = roomId;
    try {
        const response = await axios.post(requestURL, {
            userId: userId,
            clientId: clientId,
        }, {
            headers: {
                'x-api-key': apiKey,
            }
        });
    } catch (error) {
        console.error(`Error while calling resetQueryCondition API: ${error.message}`);
    }
};

export const resetQueryConditionAnchovy = async (chatUserId, requestURL, partnerId, partnerType, apiKey = undefined) => {
    try {
        const response = await axios.post(requestURL, {
            chatUserId: chatUserId,
            partnerId: partnerId,
            partnerType: partnerType,
        }, {
            headers: {
                'x-api-key': apiKey,
            }
        });
    } catch (error) {
        console.error(`Error while calling resetQueryCondition API: ${error.message}`);
    }
};

export const requestSignup = async (email, password='', company = '', job = '') => {
    try {
        const response = await axios.post(
            process.env.REACT_APP_DEMO_SIGNUP_URL,
            {
                email: email,
                password: password,
                company: company,
                job: job,
            }, {
                headers: {}
            }
        )
        return true
    } catch (error) {
        console.error(`Error while calling signup API: ${error.response.data.message}`);
    }
}

export const requestLogin = async (email, password) => {
    try {
        const response = await axios.post(
            process.env.REACT_APP_DEMO_LOGIN_URL,
            {
                email: email,
                password: password,
            }, {
                headers: {}
            }
        )
        return true
    } catch (error) {
        console.error(`Error while calling login API: ${error.response.data.message}`);
    }
}

export const fetchChatHistory = async (requestURL, userId, clientId, channelId = '', apiKey, setMessages) => {
    try {
        const response = await axios.post(
            requestURL,
            {
                userId: userId,
                clientId: clientId,
                channelId: channelId,
            }, {
                headers: {
                    'x-api-key': apiKey
                }
            }
        )
        if (response.data.chat) {
            const formattedChatHistory = response.data.chat.map((message) => {
                if (!message.content[0].includes('새로운 대화하기') && !message.content[0].includes('새로운 대화를 시작했어요')) {
                    if (message.product) {
                        return {
                            userId: 'Accio',
                            message: message.content,
                            example: message?.example,
                            product: message.product,
                            dialId: message.dialogueId,
                            intent: message.intent,
                        }
                    } else {
                        return {
                            userId: message.role === 'user' ? userId : 'Accio',
                            message: message.content,
                            example: message?.example,
                            dialId: message.dialogueId,
                            intent: message.intent,
                            time: new Date().toString(),
                        }
                    };
                };
                return null;
            });
            setMessages(formattedChatHistory.filter(Boolean));
            return formattedChatHistory.filter(Boolean).length > 0;
        } else {
            return false;
        }
    } catch (error) {
        console.error('fetchChatHistory err: ', error);
    }
}

export const fetchStartingPhrase = async (userId, requestURL) => {
    try {
        const response = await axios.get(
            requestURL, {
                params: {
                    randomId: userId,
                }
            }
        )
        // const startingPhrase = JSON.parse(response.data.body).startingPhrase;
        return response.data.body.startingPhrase;
    } catch (error) {
        console.error(`Error while calling fetchStartingPhrase API: ${error.response.data.message}`)
    }
}

export const initStartingPhrase = async (userId, requestURL) => {
    try {
        const response = await axios.post(
            requestURL,
            {
                randomId: userId,
            }, {
                headers: {}
            }
        )
        // const startingPhrase = JSON.parse(response.data.body).startingPhrase;
        return response.data.body;
    } catch (error) {
        console.error(`Error while calling fetchStartingPhrase API: ${error.response.data.message}`)
    }
}

export const sendFeedback = async (clientId, channelId, userId, requestMessage, apiKey) => {
    try {
        const response = await axios.post(
            process.env.REACT_APP_CUST_FEEDBACK_CKAT_URL,
            {
                clientId: clientId,
                channelId: channelId,
                userId: userId,
                requestMessage,
            }, {
                headers: {
                    'x-api-key': apiKey
                }
            }
        )
        return '피드백이 접수되었어요!';
    } catch (error) {
        console.error(`Error while calling sendFeedback API: ${error.response}`)
    }
}

export const fetchExample = async (userId, clientId, itemId = 'general') => {
    try {
        const response = await axios.post(
            process.env.REACT_APP_CUST_EXAM_DLST_URL,
            {
                userId: userId,
                clientId: clientId,
                itemId: itemId,
            }, {
                headers: {}
            }
        )
        return response.data.example;
    } catch (error) {
        console.error(`Error while calling fetchExample API: ${error}`);
    }
}

export const fetchExampleAnchovy = async (requestUrl, chatUserId, partnerId, itemId = 'general', apiKey) => {
    try {
        const response = await axios.post(
            requestUrl,
            {
                chatUserId: chatUserId,
                partnerId: partnerId,
                itemId: itemId,
            }, {
                headers: {
                    'x-api-key': apiKey
                }
            }
        )
        return response.data.example;
    } catch (error) {
        console.error(`Error while calling fetchExample API: ${error}`);
    }
}

export const fetchFloatingProduct = async (requestURL, payload) => {
    try {
        const response = await axios.post(
            requestURL, 
            {
                itemId: payload.itemId,
                userId: payload.chatUserId,
                target: payload.type,
                channelId: JSON.parse(payload.isMobile) ? 'mobile' : 'web',
            }
        )

        return response.data
    } catch (error) {
        console.error(`Error while calling fetchFloatingProduct API: ${error}`)
    }
}

export const logEvent = async (requestURL, payload) => {
    try {
        const response = await axios.post(
            requestURL,
            {
                eventCategory: payload.event,
                partnerId: payload.partnerId,
                chatUserId: payload.chatUserId,
                channelId: payload.channelId,
                products: payload.products || [],
            },
        )
        // const startingPhrase = JSON.parse(response.data.body).startingPhrase;
        return response.data.body;
    } catch (error) {
        console.error(`Error while calling logEvent API: ${error.response.data.message}`)
    }
}

export const fetchChatbotData = async (requestURL, partnerId) => {
    try {
        const response = await axios.get(
            requestURL + `/${partnerId}`,
            {
                params: {
                    partnerId: partnerId,
                },
                headers: {}
            }
        )
        return response.data || false;
    } catch (error) {
        console.error(`Error while calling fetchChatbotList API: ${error}`)
    }
}

export const fetchRecommendProducts = async (requestURL, chatbotId) => {
    try {
        const response = await axios.get(
            requestURL + `/${chatbotId}`,
            {
                params: {
                    chatbotId: chatbotId,
                },
                headers: {}
            }
        )

        return response.data.products;
    } catch (error) {
        console.error(`Error while calling fetchRecommendProducts API: ${error}`)
    }
}